import store from '../store/index';
import { TABLE_NUM_ITEMS } from '../constants';

const ingredientsGuard = (to, from, next) => {
  store.dispatch('ingredients/LoadIngredients', { offset: 0, limit: TABLE_NUM_ITEMS, conditions: "%20type%20LIKE%20'%25COMPOUND%25'" }).then(() => next());
  store.dispatch('ingredients/LoadAllergens').then(() => next());
}

export default ingredientsGuard;
